function DoubleCheckBulletIcon() {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width="47"
      height="47"
      fill="none"
      viewBox="0 0 47 47"
    >
      <path
        className="icon"
        d="M24.263 17.35c.205-.205.478-.318.762-.316.283.002.555.12.757.328.203.207.32.49.327.786.008.297-.095.585-.287.804l-5.815 7.614c-.1.113-.22.203-.355.266a1.051 1.051 0 01-1.22-.236l-3.856-4.037a1.144 1.144 0 01-.253-.372 1.189 1.189 0 01.226-1.275 1.09 1.09 0 01.363-.252 1.048 1.048 0 01.854.016c.135.063.255.153.355.265l3.052 3.194 5.06-6.752a.39.39 0 01.03-.034zm-1.341 7.843l1.34 1.403c.105.109.228.195.365.252a1.05 1.05 0 00.854-.017c.134-.062.254-.152.354-.265l5.819-7.614a1.189 1.189 0 00-.018-1.647 1.088 1.088 0 00-.371-.241 1.05 1.05 0 00-.854.043c-.133.066-.25.16-.347.276l-5.062 6.752-.707-.741-1.375 1.799h.002z"
      ></path>
    </svg>
  );
}

export default DoubleCheckBulletIcon;
